import { getFilenameParts } from '..';

interface Input {
    file: File;
    userId: Maybe<string>;
}

/**
 * Generate an S3 key for an audio file, based upon the userId and filename.
 * Example:
 *  {
 *      file: { // this would actually be a File object with more properties
 *          name: 'my awesome track.mp3,
 *          // etc...
 *      },
 *      userId: '1622578423XX0000000000000X',
 *  },
 *
 * Results in key: '1622578423XX0000000000000X/my awesome track.mp3',
 *
 * Note that spaces are later replaced with underscores by packages/utils/src/s3/sanitizeS3Key.ts
 * @param input - {@link Input}
 * @returns string
 */
export const generateAudioFileKeyForS3 = ({ file, userId }: Input): string => {
    const userFolder = userId ?? '__unknown_user_id__';
    const { fullName, baseName, extension } = getFilenameParts(file.name);
    const baseNameFinal = baseName === null ? 'audio_file' : baseName;

    const filename =
        extension !== null
            ? `${baseNameFinal}.${Date.now()}.${extension}`
            : fullName;

    return `${userFolder}/${filename}`;
};
